import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import moment from "moment";

import { AuthContext } from "../context/Auth/AuthContext";
import LoadingSplash from "../components/LoadingSplash";

const Route = ({ element, isPrivate = false, path }) => {
  const { isAuth, loading, user } = useContext(AuthContext);
  const location = useLocation();

  const isCompanyExpired = () => {
    if (!user || !user.company || user.company.id === 1) return false;
    const dueDate = user.company.dueDate;
    if (!dueDate) return false;
    const hojeInicio = moment().startOf("day");
    const vencimentoInicio = moment(dueDate).startOf("day");
    return hojeInicio.isAfter(vencimentoInicio, "day");
  };

  if (!isAuth && isPrivate) {
    return (
      <>
        {loading && <LoadingSplash />}
        <Navigate to="/login" state={{ from: location }} replace />
      </>
    );
  }

  if (isAuth && !isPrivate) {
    return (
      <>
        {loading && <LoadingSplash />}
        <Navigate to="/" replace />
      </>
    );
  }

  if (isAuth && isPrivate && isCompanyExpired()) {
    if (path !== "/financeiro-aberto") {
      return (
        <>
          {loading && <LoadingSplash />}
          <Navigate to="/financeiro-aberto" state={{ from: location }} replace />
        </>
      );
    }
  }

  return (
    <>
      {loading && <LoadingSplash />}
      {element}
    </>
  );
};

export default Route;
